/* eslint-disable no-lone-blocks */
import axios from 'axios'
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {toast} from 'react-toastify'
import {startLoadding, stopLoading} from '../../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {fetchAsyncUserDetails} from '../../Overview/OverviewSlice/UserDetailsSlice'

import {GetAllData as customNumber} from '../../CustomNumber/CustomNumberSlice/CustomNumberSlice'
import {GetAllData as businessName} from '../../BusinessName/BusinessNameSlice/BusinessSlice'
import {ENV} from '../../../../../Utils/_helpers/EnvHelper'
import {GetCurrentData} from '../../../../../Utils/_helpers/GetCurrentData'
import {defaultRegion} from '../../../../../../_metronic/helpers'
import {REGION_API_URLS} from '../../../../../Utils/Constant/ConstantForWebsite'

const API_URL = ENV().REACT_APP_API_URL
const API_URL_V3 = ENV().REACT_APP_API_V3_URL

const fetchDataApiV3 = async (url: string, data: any, region: string) => {
  const domain = region !== defaultRegion ? (region && REGION_API_URLS[region.toUpperCase()]) || API_URL_V3 : API_URL_V3

  const response = await axios.post(`${domain}${url}`, data, {
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`, region: region},
  })

  return response.data
}
const initialState = {
  DedicatedNumbers: [],
  DedicatedNumbersListToBuy: [],
}

export const getDedicatedNumberList: any = createAsyncThunk(
  'dedicatedNumber/getDedicatedNumberList',
  async (data: any, thunkApi: any) => {
    const currentUser = GetCurrentData()

    /** To get data from international service */
    if (currentUser?.region !== defaultRegion) {
      const response = await fetchDataApiV3(
        'sender',
        {
          action: 'find_dedicated_number',
        },
        currentUser?.region as string
      )
      return {...response.data, status: true}
    }

    const response = await axios.get(`${API_URL}user/get-dedicated-number`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })

    return response.data
  }
)
export const getAvailableDedicatedNumberToPurchase: any = createAsyncThunk(
  '/getAvailableDedicatedNumberToPurchase',
  async () => {
    const currentUser = GetCurrentData()

    /** To get data from international service */
    if (currentUser?.region !== defaultRegion) {
      const result = await fetchDataApiV3(
        'sender',
        {
          action: 'find_number',
          data: {
            type: 'dedicated',
          },
        },
        currentUser?.region as string
      )

      if (result.data?.data) {
        const mapData = result.data?.data?.map((item: any) => {
          return {
            ...item,
            gateway: [item?.gateway],
          }
        })

        return {
          ...result.data,
          data: mapData,
          status: true,
        }
      }

      return result.data
    }

    const response = await axios.get(`${API_URL}user/get-numbers`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })

    return response.data
  }
)
export const unSubscribeDedicatednumber: any = createAsyncThunk(
  'setDefaultNumber/setUnsubscribedIds',
  async (id: any, thunkApi: any) => {
    const response = await axios.put(
      `${API_URL}user/unsubscribededicatednumber/${id}`,
      {},
      {
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      }
    )
    response.data.status == true && toast.success(response.data.message)
    thunkApi.dispatch(stopLoading())
    thunkApi.dispatch(getDedicatedNumberList())
    thunkApi.dispatch(fetchAsyncUserDetails())
    return response.data
  }
)

export const fetchAsyncSetDefaultNumbers: any = createAsyncThunk(
  'setDefaultNumber/fetchAsyncSetDefaultNumbers',
  async (id: any, thunkApi: any) => {
    thunkApi.dispatch(startLoadding())

    const response = await axios.put(
      `${API_URL}user/setdefaultdedicatednumber/${id?.dedicatedNumberId}`,
      id,
      {
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      }
    )

    {
      response?.status == 200 && toast.success(response.data.message)
    }

    thunkApi.dispatch(stopLoading())
    thunkApi.dispatch(getDedicatedNumberList())
    thunkApi.dispatch(customNumber())
    thunkApi.dispatch(businessName())
    thunkApi.dispatch(fetchAsyncUserDetails())
    return response.data
  }
)

const ownerDedicatedNumberSlices = createSlice({
  name: 'ownerDedicatedNumberSlices',
  initialState,
  reducers: {},
  extraReducers: {
    [getDedicatedNumberList.pending]: (state) => {},
    [getDedicatedNumberList.fulfilled]: (state, {payload}) => {
      {
        payload.status === false && toast.error(payload.message)
      }

      return {...state, DedicatedNumbers: payload}
    },
    [getDedicatedNumberList.rejected]: () => {},
    [getAvailableDedicatedNumberToPurchase.fulfilled]: (state, {payload}) => {
      return {...state, DedicatedNumbersListToBuy: payload}
    },
  },
})

export const getDedicatedNumber = (state: any) => state.ownerDedicatedNumbers.DedicatedNumbers?.data
export const getDedicatedNumberListToBuy = (state: any) =>
  state?.ownerDedicatedNumbers?.DedicatedNumbersListToBuy?.data

export default ownerDedicatedNumberSlices.reducer
